import React from 'react'
import TickIcon from '../../Assets/Images/Done_ring_round_fill.png';
import { useNavigate } from "react-router-dom";
import './MyMedicineUploadSuccess.css'

const MyMedineUploadSuccess = () => {
    const navigate = useNavigate();
  return (
    <div className="test-success-container">
    <img src={TickIcon} alt="Success Tick Icon" className="tick-icon" />
    <p className="tsuccess-messages">Your lab reports has been uploaded successfully!</p>
    <button className="thome-button" onClick={() => navigate('/home')}>Home</button>
  </div>
  )
}

export default MyMedineUploadSuccess